import { render } from "./ZohoSurvey.vue?vue&type=template&id=18a64a9e&scoped=true"
import script from "./ZohoSurvey.vue?vue&type=script&lang=js"
export * from "./ZohoSurvey.vue?vue&type=script&lang=js"

import "./ZohoSurvey.vue?vue&type=style&index=0&id=18a64a9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a64a9e"]])

export default __exports__